import {useContext, createContext} from 'react';

export const AppContext = createContext(null) //default value

export function useAppContext(){
    return useContext(AppContext);  // consumer
}